import { Box, Grid, Typography } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import { getBase64 } from '../../../../helper/images';

const DropZone = (props: any) => {
  const onDrop = useCallback((acceptedFiles) => {
    getBase64(acceptedFiles[0])
      .then(async (data: any) => {
        try {
          const { name, size } = acceptedFiles[0];
          props.handleZone(data, name, size);
        } catch (e: any) {
          console.error(e);
        }
      });
  }, []);

  const {
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: 'image/jpeg, image/png',
    multiple: false,
    maxSize: 26214400,
    onDrop,
  });

  const baseStyle = {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    backgroundColor: '#fff',
    outline: 'none',
    height: '40.5px',
    border: 1,
    borderStyle: 'solid',
    borderColor: '#E5E5E5',
    color: '#8C909D',
  };

  const focusedStyle = {
    borderColor: '#2196f3',
  };

  const acceptStyle = {
    borderColor: '#00e676',
  };

  const rejectStyle = {
    borderColor: '#ff1744',
  };

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {}),
  }), [
    isFocused,
    isDragAccept,
    isDragReject,
  ]);

  return (
    <Grid
      sx={{
        width: '100%',
        height: '100%',
        cursor: 'pointer',
      }}
      {...getRootProps({ style, className: 'dropzone' })}
    >
      <input {...getInputProps()} />
      <Box
        sx={{
          display: 'flex',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Typography
            component="p"
            variant="body1"
          >
            + Add map attachment
          </Typography>
        </Box>
      </Box>
    </Grid>
  )
}

export default DropZone;
